module.exports = __webpack_public_path__ + "assets/c532d9ebe6dc6aad72235a3f84bb086e.mp3";